import { render, staticRenderFns } from "./ReportHowert.vue?vue&type=template&id=744b91ee"
import script from "./ReportHowert.vue?vue&type=script&lang=js"
export * from "./ReportHowert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports